<template>
  <!--赛事日历-->
  <div class="gray-back" style="padding-bottom:3rem">
    <div class="map-header">
      <div class="map-time">
        <div class="daybox" v-for="(week,i) in weeks" :key="i">
          <span class="weeks-title">{{week}}</span>
        </div>
        <div
          class="map-time"
          :style="overlayShow? 'height: 5rem':''"
          @touchmove="btnMove"
          @touchstart="btnStart"
          @touchend="btnEnd"
        >
          <div v-for="(item,i) in weekdays" :key="i" class="daybox month-box">
          <span :class="i==dayIndex  ?'action weeks-title':' weeks-title'" @click="weekDay(item,i)">
            <span>{{item.day}}</span>
            <div
              v-for="(month,m) in list"
              v-if="month.title==item.year_title"
              class="solid-box-flex"
            >
              <div
                v-for="(range,key) in range_list"
                class="solid-days"
                :style="'background:#'+range[2][0]"
                v-if="item.year_times<=range[1] && range[0]<=item.year_times"
              ><span style="color:#fff">{{item.day}}</span>
              </div>
            </div>
          </span>
        </div>
        </div> 
      </div>
      <div class="year-month" v-if="!arrow">
        <span class="year-left-btn" @click="timeDownBtn">
          <img style="height:48px;width:48px" src="../../../assets/images/icon-data-left.png" alt />
        </span>
        <span style="margin:0 20px">{{yearMonth.year_month}}</span>
        <span class="year-right-btn" @click="timeUpBtn">
          <img style="height:48px;width:48px" src="../../../assets/images/icon-data-right.png" alt />
        </span>
      </div>
      <div class="onday-sai" v-if="!arrow">
        <div
          class="sai-itmes"
          style="background:#f5f5f5;border-radius:5px"
          v-for="item in daySaiList"
        >
          <div
                class="train-items-top show-two-row items-top1"
                :style="'background-image: linear-gradient(to right, #'+item.color[0]+' , #'+item.color[1]+');'"
              >
                <div class="train-items-top-city">{{item.location}}</div>
                <div class="train-items-top-time">{{item.saidate_str}} ~ {{item.saidate_end_str}}</div>
              </div>
              <div style="flex:1;" class="sai-info-box">
                <p class="sai-title show-two-row">{{item.name}}</p>
                <div class="sai-info">
                  <span class="info-status-0" v-if="item.status==1">·未开始</span>
                  <span class="info-status-1" v-else-if="item.status==2">·正在报名</span>
                  <span class="info-status-0" v-else-if="item.status==3">·报名结束</span>
                  <span class="info-status-1" v-else-if="item.status==4">·正在比赛</span>
                  <span class="info-status-0" v-else-if="item.status==5">·已结束</span>
                  <!--<span class="info-data" style="max-width:0.75rem">{{item.saidate_str}}</span>-->
                  <!--<span class="info-address" style="flex:1">{{item.location}}</span>-->
                </div>
                <div class="sai-info">
                  <div class="info-address" v-if="item.status==5" style="flex:1">
                    共有来自
                    {{item.city_count}}
                    个地市的
                    {{item.duiwu_count}}
                    支队伍
                    {{item.member_count}}
                    人参加
                  </div>
                </div>
                <div class="items-btn">
                  <div
                    class="sai-join"
                    v-if="item.status<3"
                    v-rblink="{name:'ISaiApplyFormStep1',query:{saiqu_id:item.id}}"
                  >报名</div>
                  <div
                    class="sai-into"
                    v-if="item.status!=1"
                    v-rblink="{name:'ActivityActivity',query:{id:item.activity_id}}"
                  >进入</div>
                </div>
              </div>
        </div>
      </div>
      <div class="time-change1" v-if="!arrow" @click="timeChange(1)"></div>
      <div class="time-change2" v-else @click="timeChange(2)"></div>
    </div>
    <div style="height:2.4rem"></div>

    <div class="row4">
      <img v-rblink="{name:'MyActivity'}" src="../../../assets/images/bg-sai-mine.png" />
      <img v-rblink="{name:'Activity'}" src="../../../assets/images/bg-sai-apply.png" />
      <img v-rblink="{name:'ChaSearchSai'}" src="../../../assets/images/bg-sai-score.png" />
      <img
        v-rblink="{name:'NewsList',query:{cate_id:7}}"
        src="../../../assets/images/bg-sai-file.png"
      />
    </div>
    <div style="clear: both"></div>

    <van-tabs
      v-model="active"
      class="tab-nav"
      sticky
      @click="onStatusChange"
      style="background: none ; margin-bottom: 20px;"
    >
      <van-tab title="全部"></van-tab>
      <van-tab title="正在进行"></van-tab>
      <van-tab title="计划开始"></van-tab>
      <van-tab title="已结束"></van-tab>
    </van-tabs>
    <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
      <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
        <div class="sai-data-items" v-for="month in list" v-if="month.list.length>0">
          <div class="data-times">{{month.title}}</div>
          <div class="sai-items-box">
            <div class="sai-itmes" v-for="item in month.list">
              <div
                class="train-items-top show-two-row items-top1"
                :style="'background-image: linear-gradient(to right, #'+item.color[0]+' , #'+item.color[1]+');'"
              >
                <div class="train-items-top-city">{{item.location}}</div>
                <div class="train-items-top-time">{{item.saidate_str}} ~ {{item.saidate_end_str}}</div>
              </div>
              <div style="flex:1;" class="sai-info-box">
                <p class="sai-title show-two-row">{{item.name}}</p>
                <div class="sai-info">
                  <span class="info-status-0" v-if="item.status==1">·未开始</span>
                  <span class="info-status-1" v-else-if="item.status==2">·正在报名</span>
                  <span class="info-status-0" v-else-if="item.status==3">·报名结束</span>
                  <span class="info-status-1" v-else-if="item.status==4">·正在比赛</span>
                  <span class="info-status-0" v-else-if="item.status==5">·已结束</span>
                  <!--<span class="info-data" style="max-width:0.75rem">{{item.saidate_str}}</span>-->
                  <!--<span class="info-address" style="flex:1">{{item.location}}</span>-->
                </div>
                <div class="sai-info">
                  <div class="info-address" v-if="item.status==5" style="flex:1">
                    共有来自
                    {{item.city_count}}
                    个地市的
                    {{item.duiwu_count}}
                    支队伍
                    {{item.member_count}}
                    人参加
                  </div>
                </div>
                <div class="items-btn">
                  <div
                    class="sai-join"
                    v-if="item.status<3"
                    v-rblink="{name:'ISaiApplyFormStep1',query:{saiqu_id:item.id}}"
                  >报名</div>
                  <div
                    class="sai-into"
                    v-if="item.status!=1"
                    v-rblink="{name:'ActivityActivity',query:{id:item.activity_id}}"
                  >进入</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </van-list>
    </van-pull-refresh>
    <van-overlay :show="overlayShow" @click="timeChange(1)" lock-scroll />
  </div>
</template>
<style scoped>
.gray-back >>> .van-tabs__nav {
  background: none !important;
}
.onday-sai {
  padding: 0 0.2rem;
  margin: 0.2rem auto;
  max-height: 5rem;
  overflow: scroll;
}
.solid-box-flex {
  display: flex;
  flex-direction: column-reverse;
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 4;
}

.solid-days {
  width: 100%;
  height: 100%;
  /* margin-bottom: 1px; */
}

.row4 {
  /*display: flex;*/
  /*align-items: center;*/
  /*justify-content: space-between;*/
  margin: 10px 10px;
  /*flex-wrap: wrap;*/
}
.row4 img {
  float: left;
  width: calc(25% - 10px);
  margin: 0 10px 10px 0;
}
.row1 img {
  width: 100%;
  margin: 10px 0 0 0;
}
.train-items-top-city {
  font-size: 16px;
  color: #fff;
  overflow: hidden;
}
.train-items-top-time {
  font-size: 12px;
  color: #fff;
}
.train-items-top-city {
  font-size: 16px;
  color: #fff;
  overflow: hidden;
  height: 0.88rem;
}
.train-items-top-time {
  font-size: 14px;
  color: #fff;
}
.train-items-top {
  /* flex: 1; */
  width: 1.9rem;
  height: 1.3rem;
  border-radius: 10px;
  display: flex;
  text-align: center;
  /*align-items: baseline;*/
  flex-direction: column;
  justify-content: center;
  /*padding-left: 0.1rem;*/
  margin-right: 0.1rem;
}
.year-left-btn,
.year-right-btn {
  font-size: 16px;
  display: flex;
  align-items: center;
}

.year-month {
  text-align: center;
  display: flex;
  justify-content: center;
  padding: 0 0.4rem;
  font-size: 16px;
  font-weight: bold;
  align-items: center;
}

.time-change1 {
  width: 100%;
  height: 10px;
  margin: 0.2rem 0;
  background: #fff
    url("https://static.dierqudao.com/images/dinghuoxitong/arrow-up.png")
    no-repeat center;
}

.time-change2 {
  width: 100%;
  height: 10px;
  margin: 0.2rem 0;
  background: #fff
    url("https://static.dierqudao.com/images/dinghuoxitong/arrow-down.png")
    no-repeat center;
}

.daybox {
  width: 1.07rem;
  display: flex;
  flex-direction: column;
  /* justify-content: center; */
  align-items: center;
}

.info-three {
  height: 20px;
  font-size: 14px;
  
  font-weight: 400;
  color: rgba(24, 24, 24, 1);
  line-height: 20px;
  padding-top: 0.3rem;
  background: url("https://static.dierqudao.com/images/dinghuoxitong/arrow.png")
    no-repeat 6.2rem center;
  background-size: 10px;
}

.all-shop,
.all-pay,
.not-pay {
  width: 33%;
}

.info-one p {
  margin: 0.1rem 0;
}

.info-title {
  height: 20px;
  font-size: 14px;
  
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 20px;
}

.info-row {
  height: 23px;
  font-size: 12px;
  
  font-weight: 400;
  color: rgba(17, 17, 17, 1);
  line-height: 17px;
}

.all-count p,
.all-shop p {
  text-indent: 0.2rem;
  display: flex;
  align-items: center;
}

.all-price p {
  text-indent: 0.4rem;
}

.all-pay p,
.not-pay p {
  text-indent: 0.1rem;
  display: flex;
  align-items: center;
}

.info-one {
  display: flex;
  align-items: center;
  border-bottom: 1px solid #e5e5e5;
}

.info-two {
  display: flex;
  align-items: center;
  border-bottom: 1px solid #e5e5e5;
  padding: 0.3rem 0;
}

.info-one div {
  width: 49%;
}

.map-content,
.map-order-box {
  padding: 0 0.2rem;
  margin-top: 0.3rem;
}

.order-info {
  border-radius: 10px;
  background: #fff;
  padding: 0.3rem;
}

.map-detail {
  width: 100%;
  height: 6.68rem;
  border-radius: 10px;
  background: #fff;
}

.action {
  /* background: linear-gradient(90deg,
        rgba(254, 200, 53, 1) 0%,
        rgba(255, 173, 25, 1) 100%); */
  border: 1px solid rgba(255, 173, 25, 1) !important;
}

.map-time .weeks-title {
  display: block;
  width: 35px;
  height: 30px;
  border-radius: 5px;
  text-align: center;
  line-height: 30px;
  border: 1px solid #fff;
  position: relative;
  overflow: hidden;
}
.map-time .weeks-title span {
  position: absolute;
  z-index: 3;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  margin: auto;
}

.map-time {
  width: 100%;
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
}

.map-header {
  width: 100%;
  border-radius: 0 0 10px 10px;
  background: #fff;
  padding: 0.3rem 0 0.1rem 0;
  position: fixed;
  /*height: 5.6rem;*/
  top: 0;
  z-index: 2;
}

.map-box {
  width: 100%;
  background: #efefef;
}

.weeks-title {
  font-size: 14px;
  
  font-weight: 400;
  color: rgba(102, 102, 102, 0.85);
}
.data-times {
  height: 20px;
  font-size: 14px;
  
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  line-height: 20px;
  margin-bottom: 13px;
  padding-left: 15px;
}
.sai-info-box {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  /* height: 1rem; */
}
.sai-info-box .items-btn {
  display: flex;
}
.sai-into {
  width: 1rem;
  height: 0.5rem;
  background: rgba(255, 255, 255, 1);
  border-radius: 14px;
  border: 1px solid rgba(231, 46, 41, 1);
  font-size: 12px;
  
  font-weight: 400;
  color: rgba(230, 56, 56, 1);
  line-height: 0.5rem;
  text-align: center;
}
.sai-join {
  width: 1rem;
  height: 0.5rem;
  background: linear-gradient(
    130deg,
    rgba(243, 95, 95, 1) 0%,
    rgba(228, 49, 49, 1) 100%
  );
  border-radius: 14px;
  font-size: 12px;
  margin-right: 6px;
  
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  line-height: 0.5rem;
  text-align: center;
}
.info-address,
.info-data {
  height: 16px;
  font-size: 12px;
  
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  line-height: 16px;
  overflow: hidden;
}
.info-status-0 {
  height: 16px;
  font-size: 12px;
  
  font-weight: 400;
  color: rgba(250, 173, 20, 1);
  line-height: 16px;
  /*max-width: 1.1rem;*/
  overflow: hidden;
}
.info-status-1 {
  height: 16px;
  font-size: 12px;
  
  font-weight: 400;
  color: #2e8404;
  line-height: 16px;
}
.sai-title {
  /*height: 21px;*/
  font-size: 15px;
  
  font-weight: 400;
  /* margin-bottom: 10px; */
  color: rgba(0, 0, 0, 1);
  line-height: 24px;
}
.sai-info {
  display: flex;
}
.sai-info span {
  margin-right: 10px;
}
.sai-img {
  width: 1rem;
  height: 1rem;
  display: block;
  margin-right: 10px;
}
.sai-data-items {
  width: 7.1rem;
  margin: 0 auto;
  margin-bottom: 20px;
}
.sai-itmes {
  display: flex;
  /* justify-content: space-between; */
  align-items: center;
  padding: 15px 13px;
  align-items: flex-start;
}
.sai-items-box {
  width: 7.1rem;
  /* height:323px; */
  background: rgba(255, 255, 255, 1);
  border-radius: 10px;
  padding: 10px 0;
}
.gray-back {
  background: #efefef;
}
</style>
<script>
import Vue from "vue";
import { PullRefresh, List, Toast, Sticky, Overlay } from "vant";
Vue.use(PullRefresh)
  .use(Toast)
  .use(Sticky)
  .use(Overlay);
export default {
  name: "StationApply",
  components: {
    [List.name]: List
  },
  data: function() {
    return {
      isLoading: false,
      loading: false,
      finished: false,
      overlayShow: false,
      arrow: true,
      weekdays: [],
      weeks: ["一", "二", "三", "四", "五", "六", "日"],
      dayIndex: 0,
      dayTime: Date.parse(new Date()) / 1000, //时间戳
      pageX: 0,
      pageY: 0,
      moveX: 0,
      moveY: 0,
      yearMonth: {},
      move: false,
      atMonth: 0, //当前月份,
      list: [],
      params: {
        status: 0,
        pageNo: 1,
        pageSize: 10,
        dateLine: Date.parse(new Date()) / 1000 //时间戳,精确到秒,需要和日期选择器关联
      },
      range_list: [],
      daySaiList: [], //今日赛事,
      active: 0
    };
  },
  filters: {},
  mounted() {
    let that = this;
    that.getWeekTime(that.dayTime);

    that.list = [];
    that.active = 0;
    that.params.pageNo = 1;
    that.loading = true;
    that.finished = false;
    that.getList();
  },
  watch: {},
  destroyed() {},
  methods: {
    getList() {
      let that = this;
      that.$api.get("/api/sai/datelist", that.params, res => {
        that.loading = false;
        that.isLoading = false;

        that.list = res.data.list;
        that.range_list = res.data.range_list;
        that.finished = true;
      });
    },

    onRefresh() {
      let that = this;
      that.params.pageNo = 1;
      that.getList();
    },
    onLoad() {
      // console.log(1)
      // 异步更新数据
      console.log("this.params.pageNo");

      if (this.params.pageNo > 1) {
        setTimeout(() => {
          this.getList();
        }, 500);
      }
    },

    weekDay(item, i, e) {
      // 选择日期
      let that = this;
      console.log(item.year_times);
      this.dayIndex = i;
      this.dayTime = Date.parse(item.time) / 1000;
      // console.log(this.dayIndex, this.dayTime);
      this.params.dateLine = this.dayTime;
      this.getList();
      // console.log(this.weekdays);
      if (this.weekdays.length > 7) {
        // this.getWeekTime(this.dayTime);
        // this.arrow = !this.arrow;
        this.overlayShow = true;
      }
      let daySaiList = [];
      that.list.map((items, a) => {
        if (items.list.length > 0) {
          let list2 = items.list;
          list2.map((items2, s) => {
            console.log(items2);
            if (
              items2.saidate <= item.year_times &&
              items2.saidate_end >= item.year_times
            ) {
              daySaiList.push(items2);
            }
          });
        }
      });
      this.daySaiList = daySaiList;
    },
    timeChange(i) {
      if (i == 1) {
        this.getWeekTime(this.params.dateLine);
        this.arrow = !this.arrow;
        this.overlayShow = false;
      } else {
        this.getMonthTime(this.params.dateLine);
        this.arrow = !this.arrow;
        this.overlayShow = true;
      }
      console.log(this.dayIndex);
    },
    getWeekTime(data) {
      // let now = new Date(); // 当前日期
      // console.log(now)
      let now = parseInt(data); // 当前日期
      now = new Date(now * 1000);
      let nowDayOfWeek = now.getDay(); // 今天本周的第几天
      if (nowDayOfWeek == 0) {
        nowDayOfWeek = 7;
      }
      this.dayIndex = nowDayOfWeek - 1;
      let nowDay = now.getDate(); // 当前日
      let nowMonth = now.getMonth(); // 当前月
      let nowYear = now.getYear(); // 当前年
      nowYear += nowYear < 2000 ? 1900 : 0;
      this.yearMonth = this.formatDate(now);
      let arr = [];
      for (let i = 1; i <= 7; i++) {
        arr.push(
          this.formatDate(
            new Date(now.getFullYear(), nowMonth, nowDay + i - nowDayOfWeek)
          )
        );
      }
      this.weekdays = arr;
    },
    getMonthTime(data) {
      // let now = new Date(); // 当前日期
      let now = parseInt(data); // 当前日期
      now = new Date(now * 1000);
      let nowDayOfWeek = now.getDay(); // 今天本周的第几天
      let nowDay = now.getDate(); // 当前日
      let nowMonth = now.getMonth(); // 当前月
      let nowYear = now.getYear(); // 当前年
      nowYear += nowYear < 2000 ? 1900 : 0;
      this.yearMonth = this.formatDate(now);

      let monthStartDate = new Date(nowYear, nowMonth, 1);
      let monthEndDate = new Date(nowYear, nowMonth + 1, 1);
      let days = (monthEndDate - monthStartDate) / (1000 * 60 * 60 * 24);

      //  console.log(this.formatDate(monthStartDate)); //本月开始时间
      //  console.log(monthStartDate); //本月开始时间

      let arr = [];

      for (let i = 1; i <= days; i++) {
        arr.push(this.formatDate(new Date(nowYear, nowMonth, i)));
      }
      let monthWeek = new Date(arr[0].time).getDay();
      this.dayIndex = this.formatDate(new Date()).day + monthWeek - 2;
      for (let i = 0; i < monthWeek - 1; i++) {
        arr.unshift({ time: "", day: "" });
      }
      this.weekdays = arr;
    },
    formatDate(date) {
      var myyear = date.getFullYear();
      var mymonth = date.getMonth() + 1;
      var myweekday = date.getDate();
      if (mymonth < 10) {
        mymonth = "0" + mymonth;
      }
      if (myweekday < 10) {
        myweekday = "0" + myweekday;
      }
      return {
        time: myyear + "-" + mymonth + "-" + myweekday,
        day: parseInt(myweekday),
        year_month: myyear + "年" + mymonth + "月",
        year_title: myyear + "-" + mymonth,
        year_times:
          Date.parse(myyear + "-" + mymonth + "-" + myweekday) / 1000 -
          8 * 60 * 60
      };
    },
    mGetDate(year, month) {
      let d = new Date(year, month, 0);
      return d.getDate();
    },
    btnStart(e) {
      console.log(e);
      let touch = e.touches[0];
      this.pageX = Number(touch.pageX);
      this.pageY = Number(touch.pageY);
    },
    btnMove(e) {
      let that = this;
      let touch = e.touches[0];
      this.moveX = Number(touch.pageX);
      this.moveY = Number(touch.pageY);
      that.move = true;
    },
    btnEnd(e) {
      let that = this;
      if (that.move) {
        if (that.pageX - that.moveX > 0) {
        } else if (that.pageX - that.moveX < 0) {
        }
      }
      that.move = false;
    },
    timeUpBtn() {
      let that = this;
      if (that.arrow) {
        console.log(that.arrow);
        that.dayTime = parseInt(that.dayTime) + 604800;
        that.getWeekTime(that.dayTime);
        that.pageX = 0;
        that.moveX = 0;
        that.dayIndex = -1;
      } else {
        let now = new Date();
        let nowMonth = now.getMonth(); // 当前月
        let nowYear = now.getFullYear(); // 当前年
        nowMonth += that.atMonth + 1;
        if (nowMonth > 12) {
          nowYear = nowYear + 1;
          nowMonth = 1;
        }
        that.atMonth += 1;
        let totalDay = that.mGetDate(nowYear, nowMonth, 0);
        that.dayTime = parseInt(that.dayTime) + 86400 * totalDay;
        console.log(that.dayTime);
        that.getMonthTime(that.dayTime);
        that.dayIndex = -1;
      }
    },
    timeDownBtn() {
      let that = this;
      if (that.arrow) {
        that.dayTime = parseInt(that.dayTime) - 604800;
        that.getWeekTime(that.dayTime);
        that.pageX = 0;
        that.moveX = 0;
        that.dayIndex = -1;
      } else {
        let now = new Date();
        let nowMonth = now.getMonth(); // 当前月
        let nowYear = now.getFullYear(); // 当前年
        nowMonth += that.atMonth + 1;
        if (nowMonth < 0) {
          nowYear = nowYear - 1;
          nowMonth = 12;
        }
        that.atMonth -= 1;
        let totalDay = that.mGetDate(nowYear, nowMonth, 0);
        that.dayTime = parseInt(that.dayTime) - 86400 * totalDay;
        that.getMonthTime(that.dayTime);
        that.dayIndex = -1;
      }
    },

    // 更改状态
    onStatusChange(index) {
      let that = this;
      that.params.status = index;
      that.params.pageNo = 1;

      // 激活下拉
      that.finished = false;
      that.loading = true;
      that.list = [];
      that.range_list = [];

      this.$route.query.status = 0;
      that.getList();
    }
  }
};
</script>



// WEBPACK FOOTER //
// SaiDateList.vue?33063596